export default function Logo() {
  return <h1> 🌍 My Pack List 🏝️</h1>;
}
